var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgApplePayCard = function SvgApplePayCard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "#000",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.798 8.727c.274-.334.46-.784.411-1.243-.4.02-.89.259-1.174.594-.254.286-.48.754-.42 1.194.45.038.9-.22 1.183-.545M9.204 9.358c-.654-.038-1.21.362-1.522.362s-.79-.343-1.308-.334a1.94 1.94 0 0 0-1.639.973c-.703 1.182-.185 2.935.498 3.898.332.477.731 1.001 1.258.982.498-.019.693-.314 1.298-.314s.78.314 1.308.305c.546-.01.888-.477 1.22-.954.38-.543.536-1.067.546-1.096-.01-.01-1.054-.4-1.064-1.573-.01-.981.82-1.448.86-1.477-.47-.677-1.201-.753-1.455-.772M14.897 8.03c1.422 0 2.411.956 2.411 2.348 0 1.398-1.01 2.359-2.446 2.359h-1.574v2.443h-1.137V8.03zm-1.609 3.775h1.305c.99 0 1.553-.52 1.553-1.422s-.564-1.417-1.548-1.417h-1.31zM17.605 13.698c0-.912.716-1.471 1.985-1.54l1.462-.085v-.401c0-.58-.401-.927-1.071-.927-.635 0-1.03.297-1.127.763h-1.036c.061-.941.883-1.635 2.203-1.635 1.294 0 2.122.669 2.122 1.714v3.593h-1.051v-.857h-.025c-.31.58-.985.946-1.685.946-1.046 0-1.777-.634-1.777-1.57m3.447-.47v-.412l-1.315.08c-.655.044-1.025.327-1.025.773 0 .455.385.753.974.753.767 0 1.366-.516 1.366-1.194M23.135 17.098v-.868c.08.02.263.02.355.02.507 0 .782-.208.949-.743 0-.01.096-.317.096-.322l-1.928-5.218h1.187l1.35 4.242h.02l1.351-4.242h1.157l-2 5.485c-.456 1.264-.984 1.67-2.09 1.67-.092 0-.366-.01-.447-.024"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApplePayCard);
export default ForwardRef;